<script>
    import { onMount } from 'svelte';
    import Icon from './Icon.svelte';

    export let sourceURL = '';

    let player, playButton, pauseButton;

    let updateTime, barBackground, elapsedSpanText;
    let barWidth = 0;
    let positionMarkerLeft = 0;

    let playButtonShow = true;
    let pauseButtonShow = false;

    onMount(() => {
        player = document.querySelector('audio');
        playButton = document.getElementsByClassName('play');
        pauseButton = document.getElementsByClassName('pause');
        elapsedSpanText = player?.duration || '00:00:00';
    });

    let startNupdate;

    $: {
        startNupdate = () => {
            document.querySelector('audio').pause();
            player.play();
            playButtonShow = false;
            pauseButtonShow = true;

            function pad(num, size) {
                let s = num + '';
                while (s.length < size) s = '0' + s;
                return s;
            }

            clearInterval(updateTime);
            updateTime = setInterval(function () {
                let gradients = '';
                for (let i = 0; i < player.buffered.length; i++) {
                    let perc_start = (
                        (player.buffered.start(i) / player.duration) *
                        100
                    ).toString();
                    let perc_end = (
                        (player.buffered.end(i) / player.duration) *
                        100
                    ).toString();

                    if (i > 0) {
                        gradients =
                            gradients +
                            ',#D9E2E7 ' +
                            perc_start +
                            '%,#9D9D9D ' +
                            perc_start +
                            '%' +
                            ', #9D9D9D ' +
                            perc_end +
                            '%, #D9E2E7 ' +
                            perc_end +
                            '%';
                    } else {
                        gradients =
                            gradients +
                            '#9D9D9D ' +
                            perc_start +
                            '%' +
                            ', #9D9D9D ' +
                            perc_end +
                            '%, #D9E2E7 ' +
                            perc_end +
                            '%';
                    }
                }
                gradients =
                    gradients +
                    ',#D9E2E7 ' +
                    (player.buffered.end(player.buffered.length - 1) / player.duration) *
                        100 +
                    '%, #D9E2E7';

                barBackground = 'linear-gradient(to right, #F0F0F0, ' + gradients + ')';

                let hours = pad(Math.floor(player.currentTime / 3600), 2);
                let minutes = pad(Math.floor(player.currentTime / 60), 2);
                let seconds = pad(Math.floor(player.currentTime - minutes * 60), 2);

                elapsedSpanText = hours + ':' + minutes + ':' + seconds;

                positionMarkerLeft = (player.currentTime / player.duration) * 100;

                let percentagePosition = (100 * player.currentTime) / player.duration;
                barWidth = percentagePosition;
            }, 1000);
        };
    }

    $: positionMarkerStyle = `left: ${positionMarkerLeft}%;`;
    $: barStyle = `width : ${barWidth}%;`;

    const barClick = (event) => {
        let pos_perc = event.offsetX / event.target.offsetWidth;
        player.currentTime = player.duration * pos_perc;
        startNupdate();
    };

    const playButtonClick = () => {
        startNupdate();
    };

    const pauseButtonClick = () => {
        player.pause();
        pauseButtonShow = false;
        playButtonShow = true;
        clearInterval(updateTime);
    };
</script>

<audio>
    <source src={sourceURL} type="audio/mpeg" />
    Your browser does not support the audio element.
</audio>

<div class="d-flex padding-bottom-10 player">
    <div class="left">
        <div class="playpause">
            {#if playButtonShow}<Icon
                    icon={'play'}
                    size="22"
                    on:click={playButtonClick}
                />{/if}
            {#if pauseButtonShow}<Icon
                    icon={'pause-recording'}
                    size="22"
                    on:click={pauseButtonClick}
                />{/if}
        </div>
        <div class="scrubber">
            <div class="bar" style={barStyle} on:click={barClick}>
                <div class="position-marker" style={positionMarkerStyle} />
            </div>
        </div>
    </div>

    <div class="right elapsed">
        <span>{elapsedSpanText}</span>
    </div>
</div>

<style lang="scss">
    .player {
        .left {
            flex: 1;
            display: flex;
            align-items: center;
        }

        .right {
            display: flex;
            align-items: center;
        }

        .playpause {
            cursor: pointer;
            display: flex;

            .pause {
                display: none;
            }
        }

        .scrubber {
            height: 5px;
            background: #d9e2e7;
            border-radius: 8px;
            margin: 0 10px;
            overflow: visible;
            width: 100%;
            .bar {
                height: 5px;
                background: #f3bf24;
                border-radius: 2px;
                cursor: pointer;
            }

            .position-marker {
                background: #f3bf24;
                border-radius: 50%;
                height: 9px;
                width: 9px;
                position: relative;
                top: 50%;
                transform: translateY(-50%) scale(1.5);
            }
        }

        .elapsed {
            span {
                color: #474b50;
                font-weight: 500;
                font-size: 12px;
            }
        }
    }
</style>
